export default "__VITE_ASSET__022d9ff4__"